import firestore from "src/apiService/firestore";
import { BUILD_VERSION } from "src/config";
import { getUserClaims, getUserId } from "src/config/storage";
import type { Event } from "src/interfaces/event";

export type EventRecordingExtras = {
  /** Support_Users doc id for the accountant impersonation session. */
  accountant?: string;
};

/** Internal MRG support staff — must not write analytics/events. */
export function isInternalSupportClaims(
  claims: Record<string, unknown>
): boolean {
  const role = claims.role;
  return role === "admin" || role === "viewer";
}

export function getAccountantEventFields(
  claims: Record<string, unknown>
): EventRecordingExtras {
  if (claims.role !== "accountant") return {};

  const supportUid = claims.support_uid;
  if (typeof supportUid !== "string" || !supportUid) return {};

  return { accountant: supportUid };
}

/** Returns null when the session should not record events. */
export function getEventRecordingExtras(
  claims: Record<string, unknown>
): EventRecordingExtras | null {
  if (isInternalSupportClaims(claims)) return null;
  return getAccountantEventFields(claims);
}

export async function recordEvent(
  event: Event,
  extras: EventRecordingExtras = {}
) {
  const db = firestore();
  const user = await getUserId();
  const doc = db.collection("Events").doc();
  await doc.set({
    ...event,
    ...extras,
    user,
    clientVersion: BUILD_VERSION,
    date: new Date(),
    id: doc.id,
  });
}

/** For non-React code (Redux actions, API modules, class components). Skips internal support sessions. */
export async function recordEventWithCheck(event: Event) {
  const claims = await getUserClaims();
  const extras = getEventRecordingExtras(claims);
  if (extras === null) return;
  return recordEvent(event, extras);
}
